export const ITEMS_PER_PAGE = 20;
export const ITEMS_PER_PAGE_SPARSH = 10;

